module.exports = {"411071001":"长村张街道","411071400":"龙湖街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411071.json
// module id = 1621
// module chunks = 0